/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetConvenienceDoorsSummaryQueryResponse,
  GetConvenienceDoorsSummaryQueryParams,
} from '../types/GetConvenienceDoorsSummary'

function getGetConvenienceDoorsSummaryUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/places/convenience-doors/summary/` as const,
  }
  return res
}

/**
 * @summary Convenience doors summary counts
 * {@link /api/v1/places/convenience-doors/summary/}
 */
export async function getConvenienceDoorsSummary(
  params?: GetConvenienceDoorsSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetConvenienceDoorsSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetConvenienceDoorsSummaryUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
